import React, { useEffect, useState } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { ClockIcon, AlertCircleIcon } from 'lucide-react';
const PLANS = [{
  key: 'basico',
  emoji: '💙',
  name: 'MEGAPACK MI ESPACIO INTERIOR',
  subtitle: '6 Tomos + 6 Bonos',
  idealPara: 'Padres, madres y docentes que quieren acompañar el desarrollo emocional de adolescentes de 12 a 18 años',
  oldPrice: '$65 USD',
  price: '$12.97',
  checkoutUrl: 'https://recursopack.com/cart/40978751914033:1',
  ctaText: '→ QUIERO MI MEGAPACK AHORA',
  isVip: false
}, {
  key: 'completo',
  emoji: '🏆',
  name: 'MEGAPACK + MASTER-PACK',
  subtitle: '6 Tomos + 6 Bonos + Sistema Completo de Implementación',
  idealPara: 'Familias y docentes que quieren resultados desde el primer día — con juegos, cartas, tokens, misiones y sistema de 30 días',
  oldPrice: '$95 USD',
  price: '$16.97',
  checkoutUrl: 'https://recursopack.com/cart/40978752340017:1',
  ctaText: '→ QUIERO EL MEGAPACK COMPLETO',
  badge: 'MÁS ELEGIDO',
  isVip: true
}];
export function PricingSection() {
  const fadeIn = useFadeIn();
  const [timeLeft, setTimeLeft] = useState(85408);
  useEffect(() => {
    const startDelay = setTimeout(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
      const timer = setInterval(() => {
        setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
      }, 1000);
      return () => clearInterval(timer);
    }, 3000);
    return () => clearTimeout(startDelay);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section id="pricing" className="py-20 px-4 bg-[#111111] scroll-mt-10" data-id="element-160">
      <div className="max-w-4xl mx-auto" data-id="element-161">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-162">
          {/* Countdown Block */}
          <div className="text-center mb-12" data-id="element-163">
            <div className="inline-flex items-center gap-2 bg-purple-900/60 border border-purple-500/40 text-purple-300 font-bold text-sm md:text-base px-5 py-2 rounded-full mb-6" data-id="element-164">
              <ClockIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-165" />
              <span data-id="element-166">PRECIO DE LANZAMIENTO — CIERRA EN:</span>
            </div>

            <div className="flex items-center justify-center gap-2 md:gap-3 mb-6" data-id="element-167">
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-4 py-3 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-168">
                <div className="text-3xl md:text-5xl font-black text-white" data-id="element-169">
                  {hours.toString().padStart(2, '0')}
                </div>
                <div className="text-xs md:text-sm text-gray-500 font-medium mt-1" data-id="element-170">
                  hs
                </div>
              </div>
              <span className="text-2xl md:text-4xl font-black text-purple-400" data-id="element-171">
                :
              </span>
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-4 py-3 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-172">
                <div className="text-3xl md:text-5xl font-black text-white" data-id="element-173">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <div className="text-xs md:text-sm text-gray-500 font-medium mt-1" data-id="element-174">
                  min
                </div>
              </div>
              <span className="text-2xl md:text-4xl font-black text-purple-400" data-id="element-175">
                :
              </span>
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-4 py-3 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-176">
                <div className="text-3xl md:text-5xl font-black text-white" data-id="element-177">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <div className="text-xs md:text-sm text-gray-500 font-medium mt-1" data-id="element-178">
                  seg
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 text-yellow-400 font-bold text-sm md:text-base mb-8" data-id="element-179">
              <AlertCircleIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-180" />
              <span data-id="element-181">Después sube a su precio normal. No vuelve.</span>
            </div>

            <div className="max-w-md mx-auto mb-10" data-id="element-182">
              <div className="flex items-center justify-between text-sm text-gray-400 mb-2" data-id="element-183">
                <span data-id="element-184">Cupos al precio de lanzamiento</span>
                <span className="font-bold text-yellow-400" data-id="element-185">Quedan pocos</span>
              </div>
              <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden" data-id="element-186">
                <div className="h-full rounded-full bg-gradient-to-r from-purple-600 to-purple-400" style={{
                width: '82%'
              }} data-id="element-187"></div>
              </div>
              <p className="text-xs text-gray-500 mt-1.5 text-right" data-id="element-188">
                82% de los cupos ya tomados
              </p>
            </div>
          </div>

          {/* Pricing Header */}
          <div className="text-center mb-10" data-id="element-189">
            <h2 className="text-4xl md:text-6xl font-black text-white mb-4 uppercase tracking-tight" data-id="element-190">
              ELEGÍ TU MEGAPACK
            </h2>
          </div>

          {/* Plan Cards - Side by Side */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-191">
            {PLANS.map(plan => <div key={plan.key} className={`relative rounded-2xl p-6 md:p-8 flex flex-col ${plan.isVip ? 'bg-[#0d0d1a] border-2 border-yellow-500/50' : 'bg-[#0d0d1a] border border-gray-700'}`} data-id="element-192">
                {plan.badge && <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-193">
                    <span className="inline-flex items-center gap-1.5 bg-gradient-to-r from-yellow-500 via-amber-400 to-yellow-500 text-black text-xs md:text-sm font-black px-4 py-1.5 rounded-full uppercase tracking-wider shadow-lg" data-id="element-194">
                      ⭐ {plan.badge}
                    </span>
                  </div>}

                <div className="flex items-center gap-2 mb-2 mt-2" data-id="element-195">
                  <span className="text-2xl" data-id="element-196">{plan.emoji}</span>
                  <h3 className="text-lg md:text-xl font-black text-white uppercase tracking-wide" data-id="element-197">
                    {plan.name}
                  </h3>
                </div>

                <p className={`text-sm md:text-base font-bold mb-4 ${plan.isVip ? 'text-yellow-400' : 'text-blue-400'}`} data-id="element-198">
                  {plan.subtitle}
                </p>

                <div className="bg-[#111122] border border-gray-700/50 rounded-xl p-4 mb-6 flex-1" data-id="element-199">
                  <p className="text-sm md:text-base text-gray-300" data-id="element-200">
                    <span className="font-bold italic text-white" data-id="element-201">
                      Ideal para:{' '}
                    </span>
                    {plan.idealPara}
                  </p>
                </div>

                <div className="mb-5" data-id="element-202">
                  <span className="text-base md:text-lg text-gray-500 line-through font-medium mr-2" data-id="element-203">
                    {plan.oldPrice}
                  </span>
                  <span className="text-4xl md:text-5xl font-black text-white" data-id="element-204">
                    {plan.price}
                  </span>
                </div>

                <a href={plan.checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full mb-3" data-id="element-205">
                  <div className={`w-full text-center font-black text-base md:text-lg uppercase tracking-wide py-3.5 md:py-4 rounded-xl transition-all ${plan.isVip ? 'bg-yellow-400 text-black md:hover:bg-yellow-300' : 'bg-blue-600 text-white md:hover:bg-blue-500'}`} data-id="element-206">
                    {plan.ctaText}
                  </div>
                </a>

                <p className="text-center text-xs md:text-sm text-gray-500" data-id="element-207">
                  🌎 Pagalo en tu moneda local
                </p>
              </div>)}
          </div>

          <div className="flex items-center justify-center gap-4 mt-2 text-gray-500 text-sm flex-wrap" data-id="element-208">
            <span className="flex items-center gap-1" data-id="element-209">🔒 Pago 100% seguro</span>
            <span data-id="element-210">•</span>
            <span className="flex items-center gap-1" data-id="element-211">🛡️ Garantía 7 días</span>
            <span data-id="element-212">•</span>
            <span className="flex items-center gap-1" data-id="element-213">
              💳 Mercado Pago | Tarjeta
            </span>
            <span data-id="element-214">•</span>
            <span className="flex items-center gap-1" data-id="element-215">
              🌎 Pagalo en tu moneda local
            </span>
          </div>

          {/* Master-Pack Details Section */}
          <div className="mt-20" data-id="element-216">
            <div className="text-center mb-10" data-id="element-217">
              <h3 className="text-2xl md:text-4xl font-black text-yellow-400 mb-3" data-id="element-218">
                🕊️ ¿QUÉ AGREGA EL MASTER-PACK ACCIÓN INMEDIATA?
              </h3>
              <p className="text-lg md:text-xl text-gray-300 font-medium" data-id="element-219">
                El MegaPack te da el mapa. El Master-Pack te da el vehículo para
                llegar.
              </p>
            </div>

            {/* Comparison Table */}
            <div className="overflow-x-auto mb-12" data-id="element-220">
              <table className="w-full text-sm md:text-base" data-id="element-221">
                <thead data-id="element-222">
                  <tr className="border-b border-gray-700" data-id="element-223">
                    <th className="text-left py-3 px-3 text-gray-400 font-bold" data-id="element-224">
                      Situación real
                    </th>
                    <th className="text-center py-3 px-3 text-red-400 font-bold" data-id="element-225">
                      ❌ Sin Master-Pack
                    </th>
                    <th className="text-center py-3 px-3 text-green-400 font-bold" data-id="element-226">
                      ✅ Con Master-Pack
                    </th>
                  </tr>
                </thead>
                <tbody className="text-gray-300" data-id="element-227">
                  <tr className="border-b border-gray-800" data-id="element-228">
                    <td className="py-3 px-3 font-medium" data-id="element-229">
                      Tu hijo no quiere hacer los ejercicios
                    </td>
                    <td className="py-3 px-3 text-center text-gray-500" data-id="element-230">
                      Resistencia. Material que no se usa.
                    </td>
                    <td className="py-3 px-3 text-center text-yellow-300 font-medium" data-id="element-231">
                      30 Cartas de Conexión que no parecen tarea
                    </td>
                  </tr>
                  <tr className="border-b border-gray-800" data-id="element-232">
                    <td className="py-3 px-3 font-medium" data-id="element-233">
                      No sabés cómo presentar el material
                    </td>
                    <td className="py-3 px-3 text-center text-gray-500" data-id="element-234">
                      Lo planteás como tarea y se cierran
                    </td>
                    <td className="py-3 px-3 text-center text-yellow-300 font-medium" data-id="element-235">
                      Guía de Baja Fricción — cómo presentarlo sin resistencia
                    </td>
                  </tr>
                  <tr className="border-b border-gray-800" data-id="element-236">
                    <td className="py-3 px-3 font-medium" data-id="element-237">
                      Primera semana bien, segunda desaparece
                    </td>
                    <td className="py-3 px-3 text-center text-gray-500" data-id="element-238">
                      El material queda guardado
                    </td>
                    <td className="py-3 px-3 text-center text-yellow-300 font-medium" data-id="element-239">
                      Sistema de 30 días con herramientas diarias
                    </td>
                  </tr>
                  <tr className="border-b border-gray-800" data-id="element-240">
                    <td className="py-3 px-3 font-medium" data-id="element-241">
                      Crisis emocional y no recordás qué hacer
                    </td>
                    <td className="py-3 px-3 text-center text-gray-500" data-id="element-242">
                      Buscás en el material bajo presión
                    </td>
                    <td className="py-3 px-3 text-center text-yellow-300 font-medium" data-id="element-243">
                      Scripts de Bolsillo — respuesta inmediata
                    </td>
                  </tr>
                  <tr className="border-b border-gray-800" data-id="element-244">
                    <td className="py-3 px-3 font-medium" data-id="element-245">
                      Querés gamificar el proceso
                    </td>
                    <td className="py-3 px-3 text-center text-gray-500" data-id="element-246">
                      Sin sistema de incentivos
                    </td>
                    <td className="py-3 px-3 text-center text-yellow-300 font-medium" data-id="element-247">
                      Token System con fichas recortables
                    </td>
                  </tr>
                  <tr data-id="element-248">
                    <td className="py-3 px-3 font-medium" data-id="element-249">
                      Querés medir si hay avance real
                    </td>
                    <td className="py-3 px-3 text-center text-gray-500" data-id="element-250">
                      No tenés evidencia visible
                    </td>
                    <td className="py-3 px-3 text-center text-yellow-300 font-medium" data-id="element-251">
                      Mural de Logros Invisibles con pins de avance
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Master-Pack Contents */}
            <div className="mb-12" data-id="element-252">
              <h4 className="text-xl md:text-2xl font-black text-yellow-400 mb-6 text-center" data-id="element-253">
                EL MASTER-PACK INCLUYE:
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-254">
                {[{
                emoji: '🃏',
                text: '30 Cartas de Conexión — preguntas icebreakers para el auto o la cena'
              }, {
                emoji: '💌',
                text: '15 Cartas de Validación Flash — notas para dejar en mochila o espejo'
              }, {
                emoji: '⚡',
                text: '10 Retos de 1 Minuto — micro-mindfulness sin resistencia'
              }, {
                emoji: '🎯',
                text: '8 Misiones de Autonomía — desafíos semanales de bajo riesgo'
              }, {
                emoji: '🪙',
                text: 'Token System completo con fichas recortables'
              }, {
                emoji: '📝',
                text: 'Scripts de Bolsillo para las 5 excusas más comunes'
              }, {
                emoji: '🚨',
                text: 'Scripts de Crisis para las 5 situaciones más difíciles'
              }, {
                emoji: '🏆',
                text: 'Mural de Logros Invisibles — tracker visual de avance'
              }, {
                emoji: '📓',
                text: 'Bitácora de Co-Regulación para el adulto'
              }, {
                emoji: '🎲',
                text: 'Juego de las Emociones — 20 tarjetas para toda la familia'
              }, {
                emoji: '📅',
                text: 'Plan completo de 30 días calendario día a día'
              }, {
                emoji: '📜',
                text: 'Certificado de Compromiso Familiar'
              }].map((item, i) => <div key={i} className="flex items-start gap-3 bg-[#1a1a2e] border border-gray-700/50 rounded-xl p-3.5" data-id="element-255">
                    <span className="text-xl md:text-2xl flex-shrink-0" data-id="element-256">
                      {item.emoji}
                    </span>
                    <p className="text-sm md:text-base text-gray-300 font-medium" data-id="element-257">
                      {item.text}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>

          {/* Repeated Plan Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10 mt-12" data-id="element-258">
            {PLANS.map(plan => <div key={`bottom-${plan.key}`} className={`relative rounded-2xl p-6 md:p-8 flex flex-col ${plan.isVip ? 'bg-[#0d0d1a] border-2 border-yellow-500/50' : 'bg-[#0d0d1a] border border-gray-700'}`} data-id="element-259">
                {plan.badge && <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-260">
                    <span className="inline-flex items-center gap-1.5 bg-gradient-to-r from-yellow-500 via-amber-400 to-yellow-500 text-black text-xs md:text-sm font-black px-4 py-1.5 rounded-full uppercase tracking-wider shadow-lg" data-id="element-261">
                      ⭐ {plan.badge}
                    </span>
                  </div>}

                <div className="flex items-center gap-2 mb-2 mt-2" data-id="element-262">
                  <span className="text-2xl" data-id="element-263">{plan.emoji}</span>
                  <h3 className="text-lg md:text-xl font-black text-white uppercase tracking-wide" data-id="element-264">
                    {plan.name}
                  </h3>
                </div>

                <p className={`text-sm md:text-base font-bold mb-4 ${plan.isVip ? 'text-yellow-400' : 'text-blue-400'}`} data-id="element-265">
                  {plan.subtitle}
                </p>

                <div className="mb-5" data-id="element-266">
                  <span className="text-base md:text-lg text-gray-500 line-through font-medium mr-2" data-id="element-267">
                    {plan.oldPrice}
                  </span>
                  <span className="text-4xl md:text-5xl font-black text-white" data-id="element-268">
                    {plan.price}
                  </span>
                </div>

                <a href={plan.checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full mb-3" data-id="element-269">
                  <div className={`w-full text-center font-black text-base md:text-lg uppercase tracking-wide py-3.5 md:py-4 rounded-xl transition-all ${plan.isVip ? 'bg-yellow-400 text-black md:hover:bg-yellow-300' : 'bg-blue-600 text-white md:hover:bg-blue-500'}`} data-id="element-270">
                    {plan.ctaText}
                  </div>
                </a>

                <p className="text-center text-xs md:text-sm text-gray-500" data-id="element-271">
                  🌎 Pagalo en tu moneda local
                </p>
              </div>)}
          </div>

          <div className="flex items-center justify-center gap-4 mt-2 text-gray-500 text-sm flex-wrap" data-id="element-272">
            <span className="flex items-center gap-1" data-id="element-273">🔒 Pago 100% seguro</span>
            <span data-id="element-274">•</span>
            <span className="flex items-center gap-1" data-id="element-275">🛡️ Garantía 7 días</span>
            <span data-id="element-276">•</span>
            <span className="flex items-center gap-1" data-id="element-277">
              💳 Mercado Pago | Tarjeta
            </span>
            <span data-id="element-278">•</span>
            <span className="flex items-center gap-1" data-id="element-279">
              🌎 Pagalo en tu moneda local
            </span>
          </div>
        </div>
      </div>
    </section>;
}